import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import { Link } from "react-router-dom";
import CheckmarkRow from './../../alpineComponents/checkmarkRow';
import  './../../utils/analytics';
import PaymentInfo from './../../components/paymentInfo';
import ContactForm from './../../components/contactForm';

export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <Hero
				title={'Special Workshop'}
        subtitle={'Workshop schedule coming soon'}
				backgroundImage={'images/about-hero.jpg'}
				height={'threequarter'} /*full, half,threequarter*/
        subtitlePosition={'bottom'}
        tint={'dark'}
      />
      <div className="section-padding" style={{'paddingTop':"2%"}}>
        <div className="max-width-container">
          <div className="tiny-padding">
            <div className="primary-background">
              <div className="small-max-width-container section-padding" style={{paddingBottom: "50px"}}>
                <div className="tiny-padding centered-text">
                  <h4 className="white">{'Sign up today!'}</h4>
                  <p className="white">{'Space is limited for more personalized attention.'}</p>
                </div>
                <ContactForm
                  name={true}
                  email={true}
                  phone={true}
                  gift={true}
                  buttonText={'Sign Up'}
                  subject={'Workshop Sign Up Form'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/workshops/index.js